<template>
  <div>
    <div class="modal" v-if="visible" style="width: 410px">
      <div class="headers">
        <span>条件设置</span>
      </div>
      <div class="body">
        <el-form ref="form" :model="connectionForm" label-width="70px">
          <!-- <el-row>
            <el-col :span="24"> -->
          <el-form-item label="自定义" prop="conditionCode">
            <el-select v-model="connectionForm.conditionCode" style="width:32%" placeholder="请选择">
              <el-option v-for="item in attrList" :key="item.key" :value="item.key" :label="item.name"></el-option>
            </el-select>&nbsp;
            <el-select v-model="connectionForm.conditionType" style="width:32%" placeholder="请选择">
              <el-option v-for="item in typeList" :key="item.id" :value="item.id" :label="item.label"></el-option>
            </el-select>&nbsp;
            <el-input v-model="connectionForm.conditionValue" style="width:32%" placeholder="请输入"></el-input>
          </el-form-item>
          <!-- </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-select v-model="connectionForm.conditionCode" placeholder="请选择">
                <el-option v-for="item in attrList" :key="item.key" :value="item.key" :label="item.name"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select v-model="connectionForm.conditionType" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.id" :value="item.id" :label="item.label"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-input v-model="connectionForm.conditionValue" placeholder="请输入"></el-input>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="意见" prop="type">
                <el-select v-model="connectionForm.type" placeholder="请选择">
                  <el-option :key="'connection-type-' + item.id" v-for="item in [ { name: '通过', id: 'pass' }, { name: '拒绝', id: 'reject' } ]" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- <label for="condition">自定义</label>
        <div class="condition">
          <el-select v-model="connectionForm.conditionCode" placeholder="请选择">
            <el-option v-for="item in attrList" :key="item.key" :value="item.key" :label="item.name"></el-option>
          </el-select>
          <el-select v-model="connectionForm.conditionType" placeholder="请选择">
            <el-option v-for="item in typeList" :key="item.id" :value="item.id" :label="item.label"></el-option>
          </el-select>
          <el-input v-model="connectionForm.conditionValue" placeholder="请输入"></el-input>
        </div>
        <label for="type">意见</label>
        <el-select v-model="connectionForm.type" placeholder="请选择">
          <el-option :key="'connection-type-' + item.id" v-for="item in [ { name: '通过', id: 'pass' }, { name: '拒绝', id: 'reject' } ]" :value="item.id" :label="item.name"></el-option>
        </el-select> -->
      </div>
      <div class="footer">
        <el-button v-preventReClick
            @click="handleClickCancelSaveConnection">取消</el-button>
        <el-button v-preventReClick
            @click="handleClickSaveConnection" type="primary">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// import '../assets/modal.css';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    connection: {
      type: Object,
      default: null,
    },
    attrList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      connectionForm: {
        type: null,
        sourceId: null,
        sourcePosition: null,
        destinationId: null,
        destinationPosition: null,
        name: null,
        expression: null,
        conditionKey: null,
        conditionType: null,
        conditionValue: null
      },
      // attrList: [
      //   {
      //     label: '请选择',
      //     id: ''
      //   },
      //   {
      //     label: '主键',
      //     id: 'id'
      //   }
      // ],
      typeList: [
        {
          label: '>',
          id: 0
        },
        {
          label: '=',
          id: 1
        },
        {
          label: '<',
          id: 2
        },
        {
          label: '≤',
          id: 3
        },
        {
          label: '≥',
          id: 4
        }
      ]
    };
  },
  methods: {
    async handleClickSaveConnection () {
      this.$emit('update:visible', false);
      this.$emit('update:connection', Object.assign(this.connection, {
        name: this.connectionForm.name,
        type: this.connectionForm.type,
        conditionKey: this.connectionForm.conditionKey,
        conditionType: this.connectionForm.conditionType,
        conditionValue: this.connectionForm.conditionValue,
        expression: this.connectionForm.expression,
      }));
    },
    async handleClickCancelSaveConnection () {
      this.$emit('update:visible', false);
    },
  },
  watch: {
    connection: {
      immediate: true,
      handler (val) {
        if (!val) { return; }
        console.log('val=', val)
        this.connectionForm.id = val.id;
        this.connectionForm.type = val.type;
        this.connectionForm.name = val.name;
        this.connectionForm.conditionKey = val.conditionKey == null ? '' : val.conditionKey;
        this.connectionForm.conditionType = val.conditionType;
        this.connectionForm.conditionValue = val.conditionValue == null ? '' : val.conditionValue;
        this.connectionForm.expression = val.expression;
      },
    },
  },
};
</script>

<style scope>
.modal {
  border: 1px solid #d3d3d3;
  /* box-shadow: 2px 2px 1px #d3d3d3; */
  background-color: white;
  top: 100px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.form-control {
  display: block;
  width: 100%;
  height: 30px;
  margin-bottom: 10px;
}

.footer {
  padding: 10px;
  text-align: right;
}

.footer > button {
  margin-left: 10px;
}

.body {
  padding: 10px;
}

.headers {
  padding: 10px;
  border-bottom: 1px solid #d3d3d3;
}
.condition {
  display: flex;
  justify-content: space-between;
}
.condition .el-select,
.condition .el-input {
  width: 90%;
}
</style>